export default async function html2canvasWithSettings(element) {
  const { default : html2canvas } = await import('html2canvas');
  return html2canvas(element, {
    scale  : 4,
    height : element.scrollHeight + 5,
    width  : element.scrollWidth + 4,
    y      : element.offsetTop
  });
}
